import type { Hotels_GetHotelsInfo_GetHotelsInfoQueryResponse } from "../../swagger-types/v1/index.js";
import { getFallbackImageUrl } from "../image-fixtures.js";

export const hotelsInfoResponseFake: Hotels_GetHotelsInfo_GetHotelsInfoQueryResponse = {
  hotels: [
    {
      id: 140499,
      externalHotelId: null,
      name: "Warsaw Marriott Hotel",
      amenities: [],
      starRating: 5.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "PL",
        countryName: "Poland",
        stateCode: "",
        cityName: "Warsaw",
        address: "Al. Jerozolimskie 65/79, 00-697 Warszawa",
        postalCode: "00-697",
      },
      images: [
        {
          id: 0,
          ordinal: 1,
          smallUrl: getFallbackImageUrl(),
          mediumUrl: getFallbackImageUrl(),
          largeUrl: getFallbackImageUrl(),
          caption: "",
          sources: [],
          main: true,
        },
      ],
      reviews: [],
    },
    {
      id: 315799,
      externalHotelId: null,
      name: "Melati Beach Resort & Spa",
      amenities: [],
      starRating: 5.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "TH",
        countryName: "Thailand",
        stateCode: "",
        cityName: "Koh Samui",
        address: "9/99 Moo 5, Bophut, Thongson Bay, Koh Samui, Suratthani 84320",
        postalCode: "84320",
      },
      images: [
        {
          id: 0,
          ordinal: 1,
          smallUrl: getFallbackImageUrl(),
          mediumUrl: getFallbackImageUrl(),
          largeUrl: getFallbackImageUrl(),
          caption: "",
          sources: [],
          main: true,
        },
      ],
      reviews: [],
    },
    {
      id: 122684,
      externalHotelId: null,
      name: "Crowne Plaza Melbourne",
      amenities: [],
      starRating: 4.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "AU",
        countryName: "Australia",
        stateCode: "VIC",
        cityName: "Melbourne",
        address: "1-5 Spencer Street, Melbourne, Victoria 3008",
        postalCode: "3008",
      },
      images: [
        {
          id: 0,
          ordinal: 1,
          smallUrl: getFallbackImageUrl(),
          mediumUrl: getFallbackImageUrl(),
          largeUrl: getFallbackImageUrl(),
          caption: "",
          sources: [],
          main: true,
        },
      ],
      reviews: [],
    },
    {
      id: 126891,
      externalHotelId: null,
      name: "Hard Rock Hotel Orlando",
      amenities: [],
      starRating: 4.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "US",
        countryName: "United States of America",
        stateCode: "FL",
        cityName: "Orlando",
        address: "5800 Universal Boulevard, Orlando, Florida 32819",
        postalCode: "32819",
      },
      images: [
        {
          id: 0,
          ordinal: 1,
          smallUrl: getFallbackImageUrl(),
          mediumUrl: getFallbackImageUrl(),
          largeUrl: getFallbackImageUrl(),
          caption: "",
          sources: [],
          main: true,
        },
      ],
      reviews: [],
    },
    {
      id: 105751,
      externalHotelId: null,
      name: "Alvear Palace",
      amenities: [],
      starRating: 5.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "AR",
        countryName: "Argentina",
        stateCode: "",
        cityName: "Buenos Aires",
        address: "Avda. Alvear 1891, C1129AAA Buenos Aires",
        postalCode: "C1129AAA",
      },
      images: [
        {
          id: 0,
          ordinal: 1,
          smallUrl: getFallbackImageUrl(),
          mediumUrl: getFallbackImageUrl(),
          largeUrl: getFallbackImageUrl(),
          caption: "",
          sources: [],
          main: true,
        },
      ],
      reviews: [],
    },
    {
      id: 4263978,
      externalHotelId: null,
      name: "Kimpton Maa-Lai Bangkok",
      amenities: [],
      starRating: 5.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "TH",
        countryName: "Thailand",
        stateCode: "",
        cityName: "",
        address: "78 Soi Tonson Lumpini Pathumwan, Bangkok 10330",
        postalCode: "10330",
      },
      images: [],
      reviews: [],
    },
    {
      id: 127880,
      externalHotelId: null,
      name: "Hôtel Napoléon Paris",
      amenities: [],
      starRating: 5.0,
      info: {
        reviewsSummary: null,
        reviewsRating: null,
        reviewsCount: null,
        reviewsRatingLevel: null,
        hotelDescription: null,
        checkinTime: null,
        checkoutTime: null,
        checkinInstructions: null,
      },
      location: {
        countryCode: "FR",
        countryName: "France",
        stateCode: "",
        cityName: "Thiais",
        address: "40 Avenue de Friedland, 75008 Paris",
        postalCode: "75008",
      },
      images: [
        {
          id: 0,
          ordinal: 1,
          smallUrl: getFallbackImageUrl(),
          mediumUrl: getFallbackImageUrl(),
          largeUrl: getFallbackImageUrl(),
          caption: "",
          sources: [],
          main: true,
        },
      ],
      reviews: [],
    },
  ],
};
